module.exports = __webpack_public_path__ + "03_medium_gray.31c13cce.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/03_medium_gray.png
// module id = CnHU
// module chunks = 0